import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FieldLabel } from '../components/FieldLabel';
import { fetchBayi, updateBayiKullanici } from '../services/bayiYonetimService';

const emptyForm = {
  bayiAdi: '',
  telefon: '',
  mail: '',
  adres: '',
  ilAdi: '',
  ilceAdi: '',
  aktif: true,
  kullaniciAdi: '',
  ad: '',
  soyad: '',
};

const getErrorMessage = (error, fallback) => error?.message || error?.data?.mesaj || fallback;

const BayiDetayPage = () => {
  const { id } = useParams();
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchBayi(id)
      .then((response) => {
        if (cancelled) return;
        const veri = response?.veri || {};
        setForm({
          bayiAdi: veri.bayiAdi || '',
          telefon: veri.telefon || '',
          mail: veri.mail || '',
          adres: veri.adres || '',
          ilAdi: veri.ilAdi || '',
          ilceAdi: veri.ilceAdi || '',
          aktif: veri.aktif !== false,
          kullaniciAdi: veri.yetkili?.kullaniciAdi || '',
          ad: veri.yetkili?.ad || '',
          soyad: veri.yetkili?.soyad || '',
        });
      })
      .catch((err) => {
        if (!cancelled) setError(getErrorMessage(err, 'Bayi yüklenemedi'));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSave = async () => {
    const bayiAdi = form.bayiAdi.trim();
    if (!bayiAdi) {
      setError('Bayi adı gereklidir');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const response = await updateBayiKullanici(id, {
        bayiAdi,
        telefon: form.telefon.trim() || null,
        mail: form.mail.trim() || null,
        ad: form.ad.trim() || null,
        soyad: form.soyad.trim() || null,
      });
      if (response?.basarili === false) {
        throw new Error(response?.mesaj || 'Kayıt güncellenemedi');
      }
      if (window.showNotification) window.showNotification('success', 'Bayi bilgileri kaydedildi');
    } catch (err) {
      setError(getErrorMessage(err, 'Kayıt güncellenemedi'));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <main className="main-content">
        <div className="content-wrapper">
          <div className="loading-state">Yükleniyor...</div>
        </div>
      </main>
    );
  }

  return (
    <main className="main-content">
      <div className="content-header">
        <div>
          <h1>Bayiyi Düzenle</h1>
        </div>
      </div>

      <div className="tabs">
        <button type="button" className="tab-btn active">
          Bayi Bilgileri
        </button>
      </div>

      {error && <div className="error-state small">{error}</div>}

      <div className="tab-panel">
        <div className="tab-panel-card">
          <div className="section-block">
            <FieldLabel className="section-title" as="div">Bayi Bilgileri</FieldLabel>
            <div className="form-grid">
              <label className="form-field">
                <span>Bayi Adı *</span>
                <input
                  type="text"
                  name="bayiAdi"
                  value={form.bayiAdi}
                  onChange={onChange}
                  maxLength={200}
                  minLength={2}
                  placeholder="Bayi adı"
                  required
                />
              </label>
              <label className="form-field">
                <span>Adres</span>
                <input type="text" value={form.adres || '—'} readOnly />
              </label>
              <label className="form-field">
                <span>İl</span>
                <input type="text" value={form.ilAdi || '—'} readOnly />
              </label>
              <label className="form-field">
                <span>İlçe</span>
                <input type="text" value={form.ilceAdi || '—'} readOnly />
              </label>
            </div>
          </div>

          <div className="section-block">
            <FieldLabel className="section-title" as="div">Sistem Bilgileri</FieldLabel>
            <div className="tech-service-readonly-meta">
              <div className="tech-service-readonly-meta__row">
                <span className="tech-service-readonly-meta__label">Durum</span>
                <span className="tech-service-readonly-meta__value">{form.aktif ? 'Aktif' : 'Pasif'}</span>
              </div>
              <div className="tech-service-readonly-meta__row">
                <span className="tech-service-readonly-meta__label">Panel kullanıcısı</span>
                <span className="tech-service-readonly-meta__value">
                  {form.kullaniciAdi ? (
                    <Link to={`/users/${id}/edit`} className="tech-service-readonly-meta__link">
                      {form.kullaniciAdi}
                    </Link>
                  ) : (
                    '—'
                  )}
                </span>
              </div>
            </div>
          </div>

          <div className="section-block">
            <FieldLabel className="section-title" as="div">İletişim Bilgileri</FieldLabel>
            <div className="form-grid">
              <label className="form-field">
                <span>Telefon</span>
                <input
                  type="tel"
                  name="telefon"
                  value={form.telefon}
                  onChange={onChange}
                  placeholder="Telefon"
                  maxLength={20}
                />
              </label>
              <label className="form-field">
                <span>E-posta</span>
                <input
                  type="email"
                  name="mail"
                  value={form.mail}
                  onChange={onChange}
                  placeholder="ornek@email.com"
                  maxLength={100}
                />
              </label>
              <label className="form-field">
                <span>Ad</span>
                <input type="text" name="ad" value={form.ad} onChange={onChange} maxLength={50} placeholder="Ad" />
              </label>
              <label className="form-field">
                <span>Soyad</span>
                <input type="text" name="soyad" value={form.soyad} onChange={onChange} maxLength={50} placeholder="Soyad" />
              </label>
            </div>
          </div>

          <div className="section-actions">
            <button type="button" className="primary-btn" onClick={onSave} disabled={saving}>
              {saving ? 'Kaydediliyor...' : 'Bayi Bilgilerini Kaydet'}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default BayiDetayPage;
